/* Mobile menu drawer behaviour (markup: snippets/talas-mobile-menu.liquid, styles: assets/talas-mobile-menu.css).
   common.js injects the drawer body into #mobile-drawer-main on first open and toggles .is-open; this file only adds:
   search hand-off, the "shop by type" accordion, live branch status (Asia/Dubai), Esc to close and focus handling.
   Strings come from window.TalasT (layout/theme.liquid TalasI18n), the same keys the pickup drawer uses. */
(function () {
  'use strict';
  var doc = document;
  var T = function (k, d, a) { return window.TalasT ? window.TalasT(k, d, a) : d; };
  var drawer = doc.getElementById('mobile-drawer-main');
  if (!drawer) return;

  function root() { return drawer.querySelector('[data-tmm]'); }
  function isOpen() { return drawer.classList.contains('is-open'); }
  function close() { var c = drawer.querySelector('.tmm .js-btn-close'); if (c) c.click(); }

  /* ---- branch status (same rules as the pickup drawer: ranges per day, Dubai wall clock) ---- */
  function dubaiNow() {
    /* Dubai is UTC+4 all year (no DST): plain arithmetic, same result as Intl.DateTimeFormat but without its ~25 ms first-call setup (INP on first menu open, CWV 2026-11-02) */
    try {
      var d = new Date(Date.now() + 4 * 3600000);
      return { day: d.getUTCDay(), mins: d.getUTCHours() * 60 + d.getUTCMinutes() };
    } catch (e) { return null; }
  }
  var toMin = function (s) { var a = s.split(':'); return Number(a[0]) * 60 + Number(a[1]); };
  var hhmm = function (m) { var h = Math.floor(m / 60) % 24, n = m % 60; return (h < 10 ? '0' : '') + h + ':' + (n < 10 ? '0' : '') + n; };
  function rangesOf(s) { return ((s || '').match(/\d{1,2}:\d{2}\s*[–-]\s*\d{1,2}:\d{2}/g) || []).map(function (r) { return r.split(/\s*[–-]\s*/).map(toMin); }); }
  function week(h) { var w = {}; h.split('|').forEach(function (row, i) { w[(i + 1) % 7] = row.split('=')[1] || ''; }); return w; }
  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  function status(b, now) {
    var w = week(b.h), ranges = rangesOf(w[now.day]);
    var cur = ranges.filter(function (r) { return now.mins >= r[0] && now.mins < r[1]; })[0];
    if (cur) return { open: true, text: T('open_now_closes', 'Open now · closes %t%', { t: hhmm(cur[1]) }) };
    var later = ranges.filter(function (r) { return r[0] > now.mins; })[0];
    if (later) return { open: false, text: T('pk_closed_opens_t', 'Closed · opens %t%', { t: hhmm(later[0]) }) };
    for (var k = 1; k <= 7; k++) {
      var d = (now.day + k) % 7, r = rangesOf(w[d])[0];
      if (r) return { open: false, text: T('pk_closed_opens_dt', 'Closed · opens %d% %t%', { d: k === 1 ? T('tomorrow', 'tomorrow') : T('dayshort_' + DAYS[d], DAYS[d]), t: hhmm(r[0]) }) };
    }
    return { open: false, text: T('closed', 'Closed') };
  }

  function renderBranches(r) {
    var list = r.querySelector('[data-tmm-brs]'), src = r.querySelector('[data-tmm-hours]');
    if (!list || !src) return;
    var data; try { data = JSON.parse(src.textContent); } catch (e) { return; }
    var now = dubaiNow();
    if (!list.children.length) {
      data.forEach(function (b) {
        var li = doc.createElement('li'); li.setAttribute('data-k', b.k);
        var dot = doc.createElement('i'); dot.className = 'tmm__dot'; dot.setAttribute('aria-hidden', 'true');
        var n = doc.createElement('span'); n.className = 'tmm__brn'; n.textContent = b.n;
        var s = doc.createElement('span'); s.className = 'tmm__brst';
        li.appendChild(dot); li.appendChild(n); li.appendChild(s); list.appendChild(li);
      });
    }
    if (!now) return;
    data.forEach(function (b) {
      var li = list.querySelector('[data-k="' + b.k + '"]'); if (!li) return;
      var st = status(b, now);
      li.classList.toggle('is-open', st.open);
      li.querySelector('.tmm__brst').textContent = st.text;
    });
  }

  /* ---- open / close hooks (common.js toggles .is-open on the drawer) ---- */
  var opener = null, wasOpen = false;
  function onChange() {
    var open = isOpen();
    if (open === wasOpen) return;
    wasOpen = open;
    var r = root();
    if (open && r) {
      opener = doc.activeElement;
      renderBranches(r);
      var c = r.querySelector('.tmm__close');
      if (c) setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); } }, 60);
    } else if (!open && opener && opener.focus && doc.activeElement && drawer.contains(doc.activeElement)) {
      opener.focus();
    }
  }
  if (window.MutationObserver) new MutationObserver(onChange).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen() && root()) { e.preventDefault(); close(); }
  });

  doc.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-tmm-acc],[data-tmm-search]');
    if (!t || !drawer.contains(t)) return;

    if (t.hasAttribute('data-tmm-acc')) {
      var panel = doc.getElementById(t.getAttribute('aria-controls'));
      var exp = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', exp ? 'false' : 'true');
      if (panel) panel.hidden = exp;
      return;
    }

    /* search: close the menu, then open the site search drawer the tab bar opens */
    var AT0 = window.AT;
    if (AT0 && AT0.searchDrawer && AT0.searchDrawer.openFrom) {
      /* open synchronously inside this tap so the input gets focus (mobile keyboard); the menu's own close
         re-enables page scroll ~100 ms later, so re-assert the scroll lock after it; focus returns to the menu button on close */
      var mb = doc.querySelector('.js-main-drawer-open-button');
      close();
      AT0.searchDrawer.openFrom(mb);
      setTimeout(function () { doc.documentElement.classList.add('overflow-hidden'); }, 180);
      return;
    }
    close();
    setTimeout(function () {
      var AT = window.AT;
      var b = [].slice.call(doc.querySelectorAll('.js-mobile-bar-open,.js-open-search-drawer')).filter(function (x) { return x.getClientRects().length; })[0];
      if (b) b.click(); else window.location.href = t.getAttribute('data-href') || '/search';
    }, 120);
  });

  doc.addEventListener('visibilitychange', function () { if (!doc.hidden && isOpen() && root()) renderBranches(root()); });
})();
